import script from "./PregnancyControlNote.vue?vue&type=script&setup=true&lang=js"
export * from "./PregnancyControlNote.vue?vue&type=script&setup=true&lang=js"

import "./PregnancyControlNote.vue?vue&type=style&index=0&id=6e11489a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e11489a"]])

export default __exports__